export default __webpack_public_path__ + "static/media/toolsBannerImg.10f14b75.png";